<!--
/**
 * APCWO customisation for OrangeHRM — Email Templates module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        Edit Email Template
      </oxd-text>
      <oxd-divider />
      <email-template-form
        v-if="loaded"
        :initial-value="template"
        :loading="isLoading"
        :body-error="bodyError"
        submit-label="Save"
        @submit="onSave"
        @cancel="onCancel"
      />
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@ohrm/core/util/services/api.service';
import EmailTemplateForm from '../components/EmailTemplateForm.vue';

export default {
  name: 'EditEmailTemplate',
  components: {
    'email-template-form': EmailTemplateForm,
  },
  props: {
    templateId: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/apcwo/email-templates',
    );
    return {http};
  },
  data() {
    return {
      isLoading: false,
      loaded: false,
      bodyError: null,
      template: {},
    };
  },
  created() {
    this.isLoading = true;
    this.http
      .get(this.templateId)
      .then((response) => {
        this.template = response.data.data;
        this.loaded = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    onSave(payload) {
      this.isLoading = true;
      this.bodyError = null;
      this.http
        .update(this.templateId, payload)
        .then(() => this.$toast.updateSuccess())
        .then(() => this.onCancel())
        .catch((e) => {
          const message = e?.response?.data?.error?.message;
          if (message) {
            this.bodyError = message;
            this.$toast.error({title: 'Error', message});
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onCancel() {
      navigate('/admin/viewEmailTemplates');
    },
  },
};
</script>
